<template>
  <el-dialog
    ref="dialog"
    title="大包详情"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    @close="close"
  >
    <div class="content" ref="content">
      <p>揽收单号：{{ detailInfo.pickUpOrderNo || "--" }}</p>
      <p>速卖通入库单号：{{ detailInfo.orderNoList || "--" }}</p>
      <p>预估重量（kg）：{{ detailInfo.estimatedWeight || 0 }} kg</p>
      <p>申报箱数：{{ detailInfo.estimatedBoxNumber || 0 }}箱</p>
      <p>预估体积：{{ detailInfo.estimatedVolume || 0 }}m³</p>
    </div>

    <div class="btnBox">
      <el-button type="text" @click="print" :disabled="!detailInfo.sellerId"
        >打印（{{ detailInfo.printCount || 0 }}）</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
  name: "bigPackageDetail",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      detailInfo: {},
    };
  },
  mounted() {
    if (this.currentForm.id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      const API =
        Baseurl + "aliexpressSemiHostingCollection/selectCollectionDetails";
      const sendData = { id: this.currentForm.id.id };
      const loading = this.$loading({
        target: this.$refs.content,
        text: "努力加载中...",
        background: "rgba(218,218,238,0.2)",
      });
      ajaxPost(API, sendData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.detailInfo = data || {};
        } else {
          this.$message.error(data);
        }
        loading.close();
      });
    },
    print() {
      if (this.detailInfo.url) {
        window.open(this.detailInfo.url, "_blank");
        this.updatePrimtNum();
      } else {
        const API =
          Baseurl + "aliexpressSemiHostingCollection/getCollectionPdf";
        const sendData = {
          sellerId: this.detailInfo.sellerId,
          pickUpOrderNo: this.detailInfo.pickUpOrderNo,
        };
        ajaxPost(API, sendData).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            window.open(data, "_blank");
            this.updatePrimtNum();
          } else {
            this.$message.error(data);
          }
        });
      }
    },
    //更新打印次数
    updatePrimtNum() {
      const API =
        Baseurl + "aliexpressSemiHostingCollection/updateCollectionPrintCount";
      const sendData = {
        id: this.currentForm.id.id,
      };
      ajaxPost(API, sendData).then((res) => {
        if (res.data.code === 200) {
          this.getDetail();
        }
      });
    },

    close() {
      this.$emit("cancelVisible");
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  line-height: 32px;
}

.btnBox {
  display: flex;
  justify-content: flex-end;
}
</style>
